import React from "react";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";

export default function EntryFormLayout({
    renderedSections,
    showModeButtons,
    kakouTypeButtons,
    kakouType,
    onChangeKakouType,
    entryBodyRef,
    onDragEnter,
    onInteractionCapture
}) {
    // 入力画面全体の表示レイアウトだけを担当します。
    return (
        <div
            className="kakousiji-entry"
            ref={entryBodyRef}
            onDragEnter={onDragEnter}
            onPointerDownCapture={(event) => onInteractionCapture("pointerDown", event)}
            onClickCapture={(event) => onInteractionCapture("click", event)}
            onKeyDownCapture={(event) => onInteractionCapture("keyDown", event)}
        >
            {/* sample 以外では加工区分の切替ボタンを表示します。 */}
            {showModeButtons ? (
                <Box className="kakousiji-mode-switch-wrap">
                    <Paper className="kakousiji-mode-switch-paper">
                        <div className="kakousiji-mode-switch">
                            {kakouTypeButtons.map((btn) => (
                                <button
                                    key={btn.id}
                                    type="button"
                                    className={`kakousiji-mode-switch__button${kakouType === btn.id ? " kakousiji-mode-switch__button--active" : ""}`}
                                    onClick={() => onChangeKakouType(btn.id)}
                                >
                                    {btn.label}
                                </button>
                            ))}
                        </div>
                    </Paper>
                </Box>
            ) : null}
            {renderedSections}
        </div>
    );
}
